import { type SellScreenActionTypes } from "../../Actions/SellScreen/SellScreenActions";
import { SELL_SCREEN_TOGGLE_MOBILE_OPTIONS } from "../../Actions/SellScreen/SellScreenConstants";
import { type ShopfrontActions } from "../../Utilities/Generic/ActionsHelper";

export interface MobileState {
    optionsVisible: boolean;
}

function SellScreenMobileReducer(
    state: MobileState,
    action: ShopfrontActions<SellScreenActionTypes>
): MobileState {
    if(typeof state === "undefined") {
        return {
            optionsVisible: false,
        };
    }

    switch(action.type) {
        case SELL_SCREEN_TOGGLE_MOBILE_OPTIONS:
            return {
                optionsVisible: !state.optionsVisible,
            };
        default:
            return state;
    }
}

export default SellScreenMobileReducer;
